import { Typography, Box } from '@mui/material';
import { Button, Modal, ModalProps } from 'components/ui';
import { mutateProfile } from 'hooks';
import { throttle } from 'lodash';
import { useSnackbar } from 'notistack';
import React, { ReactElement, useEffect, useState } from 'react';
import { useOrganizationsApi } from 'services/api';
import { mutate } from 'swr';

export interface RemoveAdminModalProps
  extends Pick<ModalProps, 'open' | 'onClose'> {
  organizationId: string;
  userId: string;
}

export const RemoveAdminModal = ({
  open,
  organizationId,
  userId,
  onClose,
}: RemoveAdminModalProps): ReactElement => {
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) setSubmitting(false);
  }, [open]);

  const organizationsApi = useOrganizationsApi();

  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = throttle(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitting(true);

      const result = await organizationsApi.removeAdminFromOrganization(
        organizationId,
        userId,
      );

      void mutate(`/organizations/${organizationId}`);
      void mutateProfile();

      if (result.success) return onClose?.();

      setSubmitting(false);
      enqueueSnackbar(result.error.message, { variant: 'error' });
    },
    200,
    { leading: true },
  );

  return (
    <Modal
      title="Remove this admin from the organization?"
      open={open}
      onClose={onClose}
    >
      <form onSubmit={onSubmit}>
        <Box maxWidth={394}>
          <Typography>
            The user will no longer have the admin access for this organization.
          </Typography>
        </Box>

        <Box mt={20} width="min(70vw, 685px)" display="flex">
          <Box mr={30}>
            <Button minWidth={100} inverted onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button
            type="submit"
            minWidth={100}
            variant="vibrant"
            disabled={isSubmitting}
          >
            Remove
          </Button>
        </Box>
      </form>
    </Modal>
  );
};
